var React = require('react');

function Search (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M16 16L20 20","stroke":"currentColor","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M4 10.8571C4 12.2134 4.40216 13.5391 5.15564 14.6668C5.90911 15.7944 6.98005 16.6733 8.23303 17.1923C9.48601 17.7113 10.8647 17.8471 12.1949 17.5825C13.5251 17.3179 14.7469 16.6649 15.7059 15.7059C16.6649 14.7469 17.3179 13.5251 17.5825 12.1949C17.8471 10.8647 17.7113 9.48601 17.1923 8.23303C16.6733 6.98005 15.7944 5.90911 14.6668 5.15564C13.5391 4.40216 12.2134 4 10.8571 4C9.03852 4 7.29437 4.72245 6.00841 6.00841C4.72245 7.29437 4 9.03852 4 10.8571V10.8571Z","stroke":"currentColor","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Search.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","color":"currentColor"};

module.exports = Search;

Search.default = Search;
